// pages/controleBar/mesas/MesaPage.js
import React, { useEffect, useState } from 'react';
import { useMesa } from '../../../contexts/controleBar/mesas/MesaContext';
import ModalMesaReserva from './ModalMesaReserva';
import './MesaPage.css';
import { FaChair, FaClipboardList } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const statusLabels = {
  0: { label: 'Livre', class: 'mesa-livre' },
  1: { label: 'Ocupada', class: 'mesa-ocupada' },
  2: { label: 'Agendada', class: 'mesa-agendada' },
  3: { label: 'Em Limpeza', class: 'mesa-limpeza' },
  4: { label: 'Vinculada', class: 'mesa-vinculada' },
};

const MesaPage = () => {
  const { mesas, fetchMesas, mesaSel } = useMesa();
  const [modalReserva, setModalReserva] = useState(false);  
  const navigate = useNavigate();

  useEffect(() => {
    fetchMesas();
  }, [fetchMesas]);

  const handleIncluirItens = (mesa) => {
    // Se mesa não existir ainda (id === 0), vamos passar um "payload temporário" via estado
    if (mesa.id === 0) {
      // Monta um payload temporário (sem gravar no backend ainda)
      const payloadMesa = {
        id: 0,
        mesaConfId: mesa.mesaConfId,
        codigo: mesa.codigo,
        capacidade: mesa.capacidade,
        status: 0, // Livre por padrão
      };

      // Vamos guardar isso no localStorage ou no estado global se quiser
      sessionStorage.setItem("mesaPayload", JSON.stringify(payloadMesa));

      // Navega mesmo assim — a tela saberá que ainda não existe
      navigate(`/mesaControlePage/temp-${mesa.mesaConfId}`);
    } else {
      navigate(`/mesaControlePage/${mesa.id}`);
    }
  };


  return (
    <div className="mesa-container">
      <div className="mesa-header">
        <h1 className="mesa-title">Controle de Mesas</h1>

        <button
          type="button"
          className="btn btn-primary mesa-btn-pedidos"
          onClick={() => navigate("/pedido")}
        >
          Pedidos <FaClipboardList />
        </button>
      </div>


      <div className="mesa-grid">
        {mesas.map((mesa) => {
          const status = statusLabels[mesa.status] || { label: 'Desconhecido', class: 'mesa-desconhecida' };

          return (
            <div role="button" onClick={() => handleIncluirItens(mesa)} key={mesa.mesaConfId} className={`mesa-card ${status.class}` }>
              <div className="mesa-icon">
                <FaChair size={40} />
              </div>

              <div className="mesa-info">
                <h2>Mesa {mesa.codigo}</h2>
                <p>Capacidade: {mesa.capacidade} pessoas</p>
                <span className="mesa-status">{status.label}</span>
              </div>


              {/* <div className="mesa-buttons">
                <button className="btn-mesa incluir" onClick={() => handleIncluirItens(mesa)}>
                  <FaUtensils className="icon" /> Abrir
                </button>
                <button className="btn-mesa gerenciar" onClick={() => handleGerenciar(mesa)}>
                  Gerenciar
                </button>
              </div> */}
            </div>
          );
        })}
      </div>

      <ModalMesaReserva
        open={modalReserva}
        onClose={() => setModalReserva(false)}
        mesaId={mesaSel?.id}
      />
    </div>
  );
};

export default MesaPage;